module.exports = __webpack_public_path__ + "media/images/konintodoke/konintodoke-top-main-title-left-829255df37c462457d29cb5eab84487f.svg";